module.exports = "<div class=\"disabled-project-details\">\n    <h1>\n        Project Details\n    </h1>\n\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"\">\n                <p>Project details will appear here when project is confirmed by HERO. This will include products, total costs, and financing terms.</p>\n            </div>\n        </div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/appDetail/projectDetails/disabledProjectDetails.html
// module id = 611
// module chunks = 1